import React, { useEffect, useState } from "react";
import { ReactFlow, Background, Controls, useNodesState, useEdgesState, Handle, Position, useReactFlow, ReactFlowProvider } from "@xyflow/react";
import '@xyflow/react/dist/style.css';

import NumberFlow from '@number-flow/react'


// Div
const divHeight = 290;

// Viewport
const viewPortWidth = 550;
const viewPortHeight = 320;

const viewportSizeX1Y1 = [0, 0]; // top-left corner
const viewportSizeX2Y2 = [viewPortWidth, viewPortHeight]; // bottom-right corner

// Parent Node
const parentNodeHeight = 280;

const parentX = 10;
const parentY = (viewPortHeight - parentNodeHeight) / 2;

// Child Node
const childNodeWidth = 100;
const childNodeHeight = 50;
const childNodeHeightSm = 40;

// Output Node
const outputNodeWidth = 120;
const outputNodeHeight = 80;



// Custom node with glow effect
const CircularGlowNode = ({ id, data }) => {
    return (
        <>

            <div
                style={{
                    width: parentNodeHeight,
                    height: parentNodeHeight,
                    borderRadius: 60,
                    backgroundColor: data.color2,
                    border: "2px solid" + data.color1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    animation: data.animation,
                    color: data.color1,
                    fontSize: "10px",
                    fontWeight: "bold",
                    userSelect: "none",
                    textAlign: "center",
                    padding: "5px 0px", // Add padding for better spacing
                    boxSizing: "border-box"
                }}
            >
                {data.header}
            </div>
        </>
    );
};

const childNode = ({ id, data }) => {

    const nodeHeight = data.height || childNodeHeight;
    const headerFontSize = data.headerFontSize || "10px";
    const headerEmojiWidth = data.headerEmojiWidth || "20px";

    return (
        <>
            {/* Input handle (left side) */}
            <Handle
                type="source"
                position={data.id.startsWith("ca") ? Position.Left : Position.Right}
                style={{ background: data.id.startsWith("ca") ? '#c8c8c8ff' : "#aedffeff", width: 8, height: 8, top: '40%' }}
            />
            <div
                style={{
                    width: childNodeWidth,
                    height: nodeHeight, // fits header + body
                    borderRadius: 12,
                    border: ".9px solid " + data.color1,
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    animation: data.animation,
                    fontWeight: "bold",
                    userSelect: "none",
                    textAlign: "center",
                    color: data.color0,
                    backgroundColor: "rgba(255, 255, 255, 0.25)"
                }}
            >
                {/* Header */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        // backgroundColor: data.color1,
                        padding: "2px 0px 0px 2px",
                    }}
                >
                    {/* Emoji slot */}
                    <div
                        style={{
                            width: headerEmojiWidth,
                            height: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "1px",
                            fontSize: "11px",
                        }}
                    >
                        {data.emoji || ""}
                    </div>

                    {/* Header text */}
                    <div
                        style={{
                            flex: 1,
                            textAlign: "left",
                            fontWeight: "bold",
                            color: data.color2,
                            fontSize: headerFontSize,
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                        }}
                    >
                        {data.header || ""}
                    </div>
                </div>

                {/* Divider */}
                <div
                    style={{
                        height: "1px",
                        backgroundColor: data.color1,
                    }}
                />

                {/* Body */}
                <div
                    style={{
                        flex: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "0px",
                        fontSize: "9px",
                        fontWeight: "normal",
                        color: data.color3 || "#525252ff",
                        backgroundColor: data.color0,
                    }}
                >
                    {data.body || ""}

                </div>
            </div>
        </>
    );
};

const outputNode = ({ id, data }) => {
    return (
        <>
            <Handle
                type="target"
                position={Position.Left}
                id="left-top"
                style={{
                    background: '#aedffeff',
                    width: 8,
                    height: 8,
                    top: '35%' // Position at 25% from top
                }}
            />
            <Handle
                type="target"
                position={Position.Left}
                id="left-center"
                style={{
                    background: '#aedffeff',
                    width: 8,
                    height: 8,
                    top: '50%' // Position at center (default)
                }}
            />
            <Handle
                type="target"
                position={Position.Left}
                id="left-bottom"
                style={{
                    background: '#aedffeff',
                    width: 8,
                    height: 8,
                    top: '65%' // Position at 75% from top
                }}
            />
            <Handle
                type="target"
                position={Position.Left}
                id="left-bottom2"
                style={{
                    background: '#aedffeff',
                    width: 8,
                    height: 8,
                    top: '80%' // Position at 75% from top
                }}
            />

            {data.showAdditionalCriteria && (
                <>
                    <Handle
                        type="target"
                        position={Position.Right}
                        id="right-top"
                        style={{
                            background: '#c8c8c8ff',
                            width: 8,
                            height: 8,
                            top: '35%' // Position at 25% from top
                        }}
                    />
                    <Handle
                        type="target"
                        position={Position.Right}
                        id="right-center"
                        style={{
                            background: '#c8c8c8ff',
                            width: 8,
                            height: 8,
                            top: '50%' // Position at center (default)
                        }}
                    />
                    <Handle
                        type="target"
                        position={Position.Right}
                        id="right-bottom"
                        style={{
                            background: '#c8c8c8ff',
                            width: 8,
                            height: 8,
                            top: '65%' // Position at 75% from top
                        }}
                    />
                    <Handle
                        type="target"
                        position={Position.Right}
                        id="right-bottom2"
                        style={{
                            background: '#c8c8c8ff',
                            width: 8,
                            height: 8,
                            top: '80%' // Position at 75% from top
                        }}
                    />
                </>
            )}
            <div
                style={{
                    width: outputNodeWidth,
                    height: outputNodeHeight, // fits header + body
                    borderRadius: 12,
                    border: ".9px solid " + data.color1,
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    animation: data.animation,
                    fontWeight: "bold",
                    userSelect: "none",
                    textAlign: "center",
                    color: data.color0,
                    backgroundColor: "rgba(255, 255, 255, 0.93)"
                }}
            >
                {/* Header */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        // backgroundColor: data.color1,
                        padding: "2px 5px",
                    }}
                >
                    {/* Emoji slot */}
                    <div
                        style={{
                            width: "20px",
                            height: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "1px",
                            fontSize: "11px",
                        }}
                    >
                        {data.emoji || ""}
                    </div>

                    {/* Header text */}
                    <div
                        style={{
                            flex: 1,
                            textAlign: "left",
                            fontWeight: "bold",
                            color: data.color2,
                            fontSize: "10px",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                        }}
                    >
                        {data.header || ""}
                    </div>
                </div>

                {/* Divider */}
                <div
                    style={{
                        height: "1px",
                        backgroundColor: data.color1,
                    }}
                />

                {/* Body */}
                <div
                    style={{
                        flex: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "4px",
                        fontSize: "9px",
                        fontWeight: "normal",
                        color: "#525252ff",

                        backgroundColor: data.color0,
                    }}
                >
                    {/* Provide value of 0 on first render because NumberFlow will display NaN */}
                    {typeof data.body === 'number' && !Number.isNaN(data.body) ? (
                        <NumberFlow value={data.body} />
                    ) : (
                        <span>0</span>
                    )}
                </div>
            </div>
        </>
    );
};

const nodeTypes = {
    circularGlow: CircularGlowNode,
    childNode: childNode,
    outputNode: outputNode
};



// Test Data
const nodeData = [
    {
        id: "p1",
        type: "circularGlow",
        x: parentX,
        y: parentY,
        draggable: false,
        selectable: false,
        header: "Foundational\nCriteria", // Use string with \n instead of JSX
        color1: "#00c3ffaa",
        color2: "#4faaff2d",
        animation: "pulseGlow1 4s ease-in-out infinite",
    },
    {
        id: "p2",
        type: "circularGlow",
        x: parentX + 250,
        y: parentY,
        draggable: false,
        selectable: false,
        header: "Additional\nCriteria", // Use string with \n instead of JSX
        color1: "#ff7b91ac",
        color2: "#ff7bae2a",
        animation: "pulseGlow2 4s ease-in-out infinite",
    },
    {
        id: "o1",
        type: "outputNode",
        x: 217,
        y: 70,
        draggable: false,
        emoji: "🤖",
        header: "Dating Pool",
        body: null,
        color0: "#ffffffee",
        color1: "#dadadaff",
        color2: "#0f0f0fff",
    },
    {
        id: "c1",
        type: "childNode",
        x: 20,
        y: 35,
        height: 70,
        draggable: false,
        emoji: "🩵",
        header: "Orientation",
        body: null,
        color0: "#ffffff7c",
        color1: "#dadadaff",
        color2: "#0f0f0fff",
        parentId: 'p1',
        targetHandle: "left-top"
    },
    {
        id: "c2",
        type: "childNode",
        x: 10,
        y: 115,
        draggable: false,
        emoji: "🎂",
        header: "Age",
        body: null,
        color0: "#ffffff7c",
        color1: "#dadadaff",
        color2: "#0f0f0fff",
        targetHandle: "left-center",
        parentId: 'p1',
    },
    {
        id: "c3",
        type: "childNode",
        x: 20,
        y: 175,
        draggable: false,
        emoji: "📏",
        header: "Height",
        body: "",
        color0: "#ffffff7c",
        color1: "#dadadaff",
        color2: "#0f0f0fff",
        targetHandle: "left-bottom",
        parentId: 'p1',
    },
    {
        id: "c4",
        type: "childNode",
        x: 130,
        y: 210,
        draggable: false,
        emoji: "🌻",
        height: 60,
        header: null,
        body: "",
        color0: "#ffffff7c",
        color1: "#dadadaff",
        color2: "#0f0f0fff",
        targetHandle: "left-bottom2",
        parentId: 'p1',
    },

    {
        id: "ca5",
        type: "childNode",
        x: 170,
        y: 35,
        height: childNodeHeightSm,
        draggable: false,
        emoji: "🪞",
        header: "Apperance",
        body: "",
        color0: "#ffffff7c",
        color1: "#dadadaff",
        color2: "#0f0f0fff",
        color3: "#c0c0c0ff",
        targetHandle: "right-top",
        parentId: 'p2',

    },
    {
        id: "ca6",
        type: "childNode",
        x: 170,
        y: 85,
        height: childNodeHeightSm,
        draggable: false,
        emoji: "😜",
        header: "Personality",
        body: "",
        color0: "#ffffff7c",
        color1: "#dadadaff",
        color2: "#0f0f0fff",
        color3: "#c0c0c0ff",
        targetHandle: "right-top",
        parentId: 'p2',

    },
    {
        id: "ca7",
        type: "childNode",
        x: 170,
        y: 135,
        height: childNodeHeightSm,
        draggable: false,
        emoji: "💼",
        header: "Career",
        body: "",
        color0: "#ffffff7c",
        color1: "#dadadaff",
        color2: "#0f0f0fff",
        color3: "#c0c0c0ff",
        targetHandle: "right-center",
        parentId: 'p2',
    },
    {
        id: "ca8",
        type: "childNode",
        x: 150,
        y: 230,
        height: childNodeHeightSm,
        draggable: false,
        emoji: "🙏",
        header: "Religion",
        body: "",
        color0: "#ffffff7c",
        color1: "#dadadaff",
        color2: "#0f0f0fff",
        color3: "#c0c0c0ff",
        targetHandle: "right-bottom",
        parentId: 'p2',
    },
    {
        id: "ca9",
        type: "childNode",
        x: 170,
        y: 185,
        height: childNodeHeightSm,
        draggable: false,
        emoji: "🐥🐝",
        headerEmojiWidth: "35px",
        header: "Family Plans",
        headerFontSize: "9px",
        body: "",
        color0: "#ffffff7c",
        color1: "#dadadaff",
        color2: "#0f0f0fff",
        color3: "#c0c0c0ff",
        targetHandle: "right-bottom",
        parentId: 'p2',
    },
    {
        id: "ca10",
        type: "childNode",
        x: 40,
        y: 230,
        height: childNodeHeightSm,
        draggable: false,
        emoji: "🐘🫏",
        headerEmojiWidth: "35px",
        header: "Politics",
        body: "",
        color0: "#ffffff7c",
        color1: "#dadadaff",
        color2: "#0f0f0fff",
        color3: "#c0c0c0ff",
        targetHandle: "right-bottom2",
        parentId: 'p2',
    },
    {
        id: "ca11",
        type: "childNode",
        x: 40,
        y: 180,
        height: childNodeHeightSm,
        draggable: false,
        emoji: "🎓",
        headerEmojiWidth: "35px",
        header: "Education",
        body: "",
        color0: "#ffffff7c",
        color1: "#dadadaff",
        color2: "#0f0f0fff",
        color3: "#c0c0c0ff",
        targetHandle: "right-bottom2",
        parentId: 'p2',
    }
];



// Generate initial nodes using map()
// Any key value pairs added to the section above need to be added to this section to make sure it feeds to the creation of the node type template in the first section
const generateNodes = (showAdditionalCriteria) => {
    return nodeData
        .filter(item => !item.id.startsWith('ca') && item.id !== 'p2' || showAdditionalCriteria)
        .map((item) => {
            // Your existing mapping logic stays exactly the same
            const baseNode = {
                id: item.id,
                type: item.type,
                position: { x: item.x, y: item.y },
                draggable: item.draggable || false,
                selectable: item.selectable !== false,
            };

            // Add fade-in class for additional nodes
            if ((item.id.startsWith('ca') || item.id === 'p2') && showAdditionalCriteria) {
                baseNode.className = 'fade-in';
            }

            // Rest of your existing logic...
            if (item.type === "circularGlow") {
                baseNode.data = {
                    header: item.header ?
                        <>{item.header.split('\n').map((line, i) =>
                            <React.Fragment key={i}>{line}<br /></React.Fragment>
                        )}</> : "",
                    color1: item.color1,
                    color2: item.color2,
                    animation: item.animation,
                };
            } else if (item.type === "childNode") {
                baseNode.data = {
                    id: item.id,
                    emoji: item.emoji || "",
                    header: item.header || "",
                    headerFontSize: item.headerFontSize,
                    height: item.height,
                    headerEmojiWidth: item.headerEmojiWidth,
                    body: item.body ?
                        <>{item.body.split('\n').map((line, i) =>
                            <React.Fragment key={i}>{line}<br /></React.Fragment>
                        )}</> : "?",
                    color0: item.color0,
                    color1: item.color1,
                    color2: item.color2,
                    color3: item.color3,
                };

                if (item.parentId) {
                    baseNode.parentId = item.parentId;
                    baseNode.extent = 'parent';
                }
            } else if (item.type === "outputNode") {
                baseNode.data = {
                    id: item.id,
                    emoji: item.emoji || "",
                    header: item.header || "",
                    headerFontSize: item.headerFontSize,
                    height: item.height,
                    headerEmojiWidth: item.headerEmojiWidth,
                    body: item.body ?
                        <>{item.body.split('\n').map((line, i) =>
                            <React.Fragment key={i}>{line}<br /></React.Fragment>
                        )}</> : "?",
                    color0: item.color0,
                    color1: item.color1,
                    color2: item.color2,
                    color3: item.color3,
                    showAdditionalCriteria: showAdditionalCriteria, // Add this for output nodes
                };
            }

            return baseNode;
        });
};

const generateEdges = (showAdditionalCriteria) => {
    return nodeData
        .filter(node => node.id.startsWith("c"))
        .filter(node => !node.id.startsWith("ca") || showAdditionalCriteria)
        .map(node => ({
            id: `${node.id}-o1`,
            source: node.id,
            target: "o1",
            targetHandle: node.targetHandle,
            type: 'default',
            style: {
                strokeWidth: 1.5,
                strokeLinecap: 'round',
                opacity: 0.5,
                stroke: node.id.startsWith('ca') ? '#cececeff' : '#6dc3f8ff',
            },
            animated: true,
            className: node.id.startsWith('ca') && showAdditionalCriteria ? 'fade-in' : '',
        }));
};

// Helper function to update node data
const updateNodeData = (nodes, outputKPI, genderKPI, sexualityKPI, marriageKPI, ageKPI, heightKPI, heightMeasurement, heightRange, activeRaceTab, raceKPI, ethnicityKPI, ancestryKPI, raceAll, ethnicityAll, ancestryAll) => {
    return nodes.map(node => {
        if (node.id === 'o1') {
            return {
                ...node,
                data: {
                    ...node.data,
                    body: outputKPI
                }
            };
        }
        else if (node.id === 'c1') {
            return {
                ...node,
                data: {
                    ...node.data,
                    body:
                        <>
                            {truncateAtWord(
                                genderKPI
                                    .filter(a => a.selected === true)
                                    .map(a => a["gender"])
                                    .join(", "),
                                17
                            )}
                            {<br />}
                            {truncateAtWord(
                                sexualityKPI
                                    .filter(a => a.selected === true)
                                    .map(a => a["sexuality"])
                                    .join(", "),
                                17
                            )}
                            {<br />}
                            {truncateAtWord(
                                marriageKPI
                                    .filter(a => a.selected === true)
                                    .map(a => a["marriage"])
                                    .join(", "),
                                17
                            )}
                        </>
                }
            };
        }
        else if (node.id === 'c2') {
            return {
                ...node,
                data: {
                    ...node.data,
                    body: `${ageKPI[0]} - ${ageKPI[1]} yrs old`
                }
            };
        }
        else if (node.id === 'c3') {
            return {
                ...node,
                data: {
                    ...node.data,
                    body: heightMeasurement ? (`${heightKPI[0] === heightRange[0] ? "<" : ""}${Math.floor(heightKPI[0] / 12)}'${heightKPI[0] % 12}" - ${Math.floor(heightKPI[1] / 12)}'${heightKPI[1] % 12}"${heightKPI[1] === heightRange[1] ? "+" : ""}`)
                        : (`${heightKPI[0] === heightRange[0] ? "<" : ""}${heightKPI[0]} - ${heightKPI[1]}cm${heightKPI[1] === heightRange[1] ? "+" : ""}`)
                }
            };
        }
        else if (node.id === 'c4') {
            let bodyValue;
            if (activeRaceTab === 0) { bodyValue = [raceKPI, "race", raceAll] }
            else if (activeRaceTab === 1) { bodyValue = [ethnicityKPI, "ethnicity", ethnicityAll] }
            else if (activeRaceTab === 2) { bodyValue = [ancestryKPI, "ancestry", ancestryAll] }

            return {
                ...node,
                data: {
                    ...node.data,
                    header: bodyValue[1].charAt(0).toUpperCase() + bodyValue[1].slice(1),
                    body: bodyValue[2]
                        ? "All"
                        : truncateAtWord(
                            bodyValue[0]
                                .filter(a => a.selected === true)
                                .map(a => a[bodyValue[1]])
                                .join(", "),
                            34
                        )
                }
            };
        }
        // Add default data for additional criteria nodes (ca5-ca11)
        else if (node.id.startsWith('ca')) {
            return {
                ...node,
                data: {
                    ...node.data,
                    body: node.data.body || ""
                }
            };
        }
        return node;
    });
};

function truncateAtWord(str, maxLength) {
    if (str.length <= maxLength) return str;

    // Find the last space before the maxLength
    const truncated = str.substring(0, maxLength);
    const lastSpaceIndex = truncated.lastIndexOf(' ');

    // If no space found, truncate at character limit
    if (lastSpaceIndex === -1) return truncated + '...';

    // Truncate at the last complete word
    return truncated.substring(0, lastSpaceIndex) + '...';
}

export function DiagramContent({
    outputKPI,
    genderKPI,
    sexualityKPI,
    marriageKPI,
    ageKPI,
    heightKPI,
    heightMeasurement,
    heightRange,
    activeRaceTab,
    raceKPI,
    ethnicityKPI,
    ancestryKPI,
    raceAll,
    ethnicityAll,
    ancestryAll,
    showAdditionalCriteria,
    returnToFoundationalCriteria
}) {
const [nodes, setNodes, onNodesChange] = useNodesState(generateNodes(showAdditionalCriteria));
const [edges, setEdges, onEdgesChange] = useEdgesState(generateEdges(showAdditionalCriteria));

    const { setViewport } = useReactFlow();

    useEffect(() => {
        if (showAdditionalCriteria) {
            setViewport(
                { x: -210, y: -15 },
                { duration: 1500 }
            )
        }
    }, [showAdditionalCriteria]);

    useEffect(() => {
        if (returnToFoundationalCriteria) {
            setViewport(
                { x: -10, y: -15 },
                { duration: 1000 }
            )
        }
    }, [returnToFoundationalCriteria]);

    // Handle showing/hiding additional criteria
    useEffect(() => {
        const newNodes = generateNodes(showAdditionalCriteria);
        const newEdges = generateEdges(showAdditionalCriteria);

        // Update nodes and edges with current data
        const updatedNodes = updateNodeData(
            newNodes,
            outputKPI,
            genderKPI,
            sexualityKPI,
            marriageKPI,
            ageKPI,
            heightKPI,
            heightMeasurement,
            heightRange,
            activeRaceTab,
            raceKPI,
            ethnicityKPI,
            ancestryKPI,
            raceAll,
            ethnicityAll,
            ancestryAll
        );

        setNodes(updatedNodes);
        setEdges(newEdges);
    }, [showAdditionalCriteria, setNodes, setEdges]);

    // Update node data when any of the KPI values change
    useEffect(() => {
        setNodes(currentNodes => updateNodeData(
            currentNodes,
            outputKPI,
            genderKPI,
            sexualityKPI,
            marriageKPI,
            ageKPI,
            heightKPI,
            heightMeasurement,
            heightRange,
            activeRaceTab,
            raceKPI,
            ethnicityKPI,
            ancestryKPI,
            raceAll,
            ethnicityAll,
            ancestryAll
        ));
    }, [
        outputKPI,
        genderKPI,
        sexualityKPI,
        marriageKPI,
        ageKPI,
        heightKPI,
        heightMeasurement,
        heightRange,
        activeRaceTab,
        raceKPI,
        ethnicityKPI,
        ancestryKPI,
        raceAll,
        ethnicityAll,
        ancestryAll,
        setNodes
    ]);

    return (
        <div className="estimateDiagramContainerParent">
            <div className="standardContainer" style={{ marginTop: "10px", marginBottom: "10px" }}>
                <div style={{ height: divHeight, width: "100%" }}>

                    <ReactFlow
                        nodes={nodes}
                        edges={edges}
                        onNodesChange={onNodesChange}
                        onEdgesChange={onEdgesChange}
                        nodeTypes={nodeTypes}
                        // attributionPosition={false}
                        defaultViewport={{ x: -10, y: -15, zoom: 1 }}
                        minZoom={.7}
                        maxZoom={3}
                        translateExtent={[
                            viewportSizeX1Y1,           // top-left corner
                            viewportSizeX2Y2,     // bottom-right corner
                        ]}

                        elementsSelectable={false} // This disables all element selection
                        nodesDraggable={false} // Re-enable node dragging if needed
                        nodesConnectable={false} // Prevent new edge creation
                        panOnDrag={false}
                        panOnScroll={false}
                        zoomOnScroll={false}
                        zoomOnPinch={false}
                    >
                        <Background
                            variant="dots"
                            gap={10}
                            size={1}
                            color="#ccc"
                        />
                        {/* <Controls /> */}
                    </ReactFlow>
                </div>
            </div>
        </div>
    );
}


export default function DiagramEstimates(props) {
    return (
        <ReactFlowProvider>
            <DiagramContent {...props} />
        </ReactFlowProvider>
    );
}